// // import styles from "./FeaturedHotels.module.css";
// // import FeaturedHotelGrid from "./FeaturedHotelGrid";

// // export default function FeaturedHotels({ hotels }) {
// //   const featuredHotels =
// //     hotels?.filter((hotel) => hotel.is_featured) || [];
// // console.log("Hotels:", hotels);
// // console.log("First Hotel:", hotels?.[0]);
// //   if (featuredHotels.length === 0) return null;

// //   return (
// //     <section className={styles.section}>

// //       <div className={styles.header}>

// //         <span className={styles.badge}>
// //           Featured Venues
// //         </span>

// //         <h2 className={styles.heading}>
// //           Discover Premium Event Venues
// //         </h2>

// //         <p className={styles.description}>
// //           Explore our handpicked collection of luxury hotels offering
// //           exceptional ballrooms, meeting spaces, and event venues for
// //           corporate gatherings, conferences, weddings, and celebrations.
// //         </p>

// //       </div>

// //       <FeaturedHotelGrid hotels={featuredHotels} />

// //     </section>
// //   );
// // }

// import styles from "./FeaturedHotels.module.css";

// import FeaturedHotelGrid from "./FeaturedHotelGrid";

// import HotelList from "../HotelGrid/HotelListview";
// import HotelMap from "../HotelGrid/HotelMapview";
// import HotelViewToggle from "../HotelGrid/HotelViewToggle";


// export default function FeaturedHotels({
//   hotels,
//   viewMode,
//   onViewChange,
// }) {

//   const featuredHotels =
//     hotels?.filter(
//       (hotel) => hotel.is_featured
//     ) || [];


//   console.log(
//     "Hotels:",
//     hotels
//   );

//   console.log(
//     "First Hotel:",
//     hotels?.[0]
//   );


//   if (
//     featuredHotels.length === 0
//   ) {
//     return null;
//   }


//   return (

//     <section
//       className={
//         styles.section
//       }
//     >

//       {/* ==========================================
//           HEADER
//       ========================================== */}

//       <div
//         className={
//           styles.header
//         }
//       >

//         <div>

//           <span
//             className={
//               styles.badge
//             }
//           >
//             Featured Venues
//           </span>

//           <h2
//             className={
//               styles.heading
//             }
//           >
//             Discover Premium Event Venues
//           </h2>

//           <p
//             className={
//               styles.description
//             }
//           >
//             Explore our handpicked collection
//             of luxury hotels offering
//             exceptional ballrooms, meeting
//             spaces, and event venues for
//             corporate gatherings, conferences,
//             weddings, and celebrations.
//           </p>

//         </div>


//         {/* ==========================================
//             VIEW TOGGLE
//         ========================================== */}

//         <HotelViewToggle
//           viewMode={viewMode}
//           onChange={onViewChange}
//         />

//       </div>


//       {/* ==========================================
//           GRID / LIST
//       ========================================== */}

//     {viewMode === "grid" && (
//   <FeaturedHotelGrid
//     hotels={featuredHotels}
//   />
// )}

// {viewMode === "list" && (
//   <HotelList
//     hotels={featuredHotels}
//   />
// )}

// {viewMode === "map" && (
//   <HotelMap
//     hotels={featuredHotels}
//   />
// )}

//     </section>

//   );
// }


import styles from "./FeaturedHotels.module.css";

import FeaturedHotelGrid from "./FeaturedHotelGrid";

import HotelList from "../HotelGrid/HotelListview";
import HotelMap from "../HotelGrid/HotelMapview";
import HotelViewToggle from "../HotelGrid/HotelViewToggle";


export default function FeaturedHotels({
  hotels,
  viewMode,
  onViewChange,
}) {

  // const featuredHotels =
  //   hotels?.filter(
  //     (hotel) => hotel.is_featured
  //   ) || [];
const featuredHotels =
  hotels?.filter((hotel) => hotel.is_featured) || [];

const randomFeaturedHotels = [...featuredHotels]
  .sort(() => Math.random() - 0.5)
  .slice(0, 12);

  console.log(
    "Hotels:",
    hotels
  );

  console.log(
    "First Hotel:",
    hotels?.[0]
  );


  if (
    featuredHotels.length === 0
  ) {
    return null;
  }


  return (

    <section
      className={
        styles.section
      }
    >


      <div
        className={
          styles.header
        }
      >

        <div>

          <span
            className={
              styles.badge
            }
          >
            Featured Venues
          </span>

          <h2
            className={
              styles.heading
            }
          >
            Discover Premium Event Venues
          </h2>

          <p
            className={
              styles.description
            }
          >
            Explore our handpicked collection
            of luxury hotels offering
            exceptional ballrooms, meeting
            spaces, and event venues for
            corporate gatherings, conferences,
            weddings, and celebrations.
          </p>

        </div>

        <HotelViewToggle
          viewMode={viewMode}
          onChange={onViewChange}
        />

      </div>


    {/* {viewMode === "grid" && (
  <FeaturedHotelGrid
    hotels={featuredHotels}
  />
)}

{viewMode === "list" && (
  <HotelList
    hotels={featuredHotels}
  />
)}

{viewMode === "map" && (
  <HotelMap
    hotels={featuredHotels}
  />
)} */}
{viewMode === "grid" && (
  <FeaturedHotelGrid hotels={randomFeaturedHotels} />
)}

{viewMode === "list" && (
  <HotelList hotels={randomFeaturedHotels} />
)}

{viewMode === "map" && (
  <HotelMap hotels={randomFeaturedHotels} />
)}
    </section>

  );
}